'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class; // Lib


// keyboard actions


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _keyboardShortcuts = require('../../utils/keyboard/keyboardShortcuts');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WorkspaceKeyboardShortcutHandler = (_dec = (0, _reactRedux.connect)(), _dec(_class = function (_React$Component) {
    _inherits(WorkspaceKeyboardShortcutHandler, _React$Component);

    function WorkspaceKeyboardShortcutHandler() {
        _classCallCheck(this, WorkspaceKeyboardShortcutHandler);

        return _possibleConstructorReturn(this, (WorkspaceKeyboardShortcutHandler.__proto__ || Object.getPrototypeOf(WorkspaceKeyboardShortcutHandler)).apply(this, arguments));
    }

    _createClass(WorkspaceKeyboardShortcutHandler, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var _props = this.props,
                currentBoardId = _props.currentBoardId,
                currentBoard = _props.currentBoard,
                isEditable = _props.isEditable,
                dispatch = _props.dispatch;

            this.keyboardManager = (0, _keyboardShortcuts.bindShortcuts)(dispatch);
            this.keyboardManager.setProps({ currentBoardId: currentBoardId, currentBoard: currentBoard, isEditable: isEditable });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var currentBoardId = nextProps.currentBoardId,
                currentBoard = nextProps.currentBoard,
                isEditable = nextProps.isEditable;

            if (this.keyboardManager) this.keyboardManager.setProps({ currentBoardId: currentBoardId, currentBoard: currentBoard, isEditable: isEditable });
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.keyboardManager) this.keyboardManager.unbind();
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);

    return WorkspaceKeyboardShortcutHandler;
}(_react2.default.Component)) || _class);


WorkspaceKeyboardShortcutHandler.propTypes = {
    currentBoardId: _propTypes2.default.string,
    currentBoard: _propTypes2.default.object,
    isEditable: _propTypes2.default.bool,
    dispatch: _propTypes2.default.func
};

exports.default = WorkspaceKeyboardShortcutHandler;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/decorators/WorkspaceKeyboardShortcutHandler.js
// module id = 2153
// module chunks = 0